import { LocalStorageContainer } from '@frontend/shared/src/helpers/LocalStorageContainer';

export const PersistentWallOfShameAPIKey = new LocalStorageContainer<
  { value: string },
  string,
  string
>('__WALL_OF_SHAME_API_KEY__', {
  fromLocalStorageModel: ({ value }) => value,
  toLocalStorageModel: value => ({ value }),
});
